import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

/**
 * Compact checklist shown in the chat after a step completes: every core
 * step on one line, finished ones checked, the just-finished one
 * highlighted, and the next one marked.
 */
export default function SetupChecklistCard({ items, highlightKeys = [] }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const done = items.filter((item) => item.status === "done" || item.status === "skipped").length;
  return (
    <div
      className="my-2 rounded-lg border border-violet-200 bg-white px-3 py-2 text-sm"
      role="group"
      aria-label="Setup checklist"
    >
      <div className="flex items-center justify-between text-[11px] uppercase tracking-wide text-violet-700 mb-1.5">
        <span>Setup checklist</span>
        <span className="text-gray-500 normal-case tracking-normal">{done} of {items.length} done</span>
      </div>
      <ul className="space-y-1">
        {items.map((item) => {
          const highlighted = highlightKeys.includes(item.key);
          const rowClass =
            item.status === "next"
              ? "text-violet-800 font-medium"
              : item.status === "done" || item.status === "skipped"
              ? highlighted ? "text-green-700 font-medium" : "text-gray-500"
              : "text-gray-400";
          return (
            <li key={item.key} className={`flex items-center gap-2 ${rowClass}`}>
              {item.status === "done" ? (
                <CheckCircleIcon fontSize="inherit" className={highlighted ? "text-green-600" : "text-green-500/70"} />
              ) : item.status === "skipped" ? (
                <RemoveCircleOutlineIcon fontSize="inherit" className="text-gray-400" />
              ) : item.status === "next" ? (
                <ArrowForwardIcon fontSize="inherit" className="text-violet-600" />
              ) : (
                <RadioButtonUncheckedIcon fontSize="inherit" className="text-gray-300" />
              )}
              <span>
                {item.label}
                {item.status === "skipped" && <span className="text-xs text-gray-400"> (skipped)</span>}
                {item.status === "next" && <span className="text-xs text-violet-500"> (next)</span>}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
